import { useSyncPanelsPreferences } from "./use-sync-panels-preferences"
import { useSyncModelPreferences } from "./use-sync-model-preferences"
import { useSyncCorePreferences } from "./use-sync-core-preferences"
import { useSyncTradePreferences } from "./use-sync-trade-preferences"

export function useDashboardPreferencesSync(): boolean {
  const panelsLoaded = useSyncPanelsPreferences()
  const modelLoaded = useSyncModelPreferences()
  const coreLoaded = useSyncCorePreferences()
  const tradeLoaded = useSyncTradePreferences()

  return [panelsLoaded, modelLoaded, coreLoaded, tradeLoaded].every(Boolean)
}
